import { type SerializedStyles } from '@emotion/react';
import {
  type FC, useMemo,
} from 'react';
import {
  Accordion, type AccordionHeaderSize,
} from '~/_shared/baseComponents/accordion/index';
import { OverlayLoaderComponent } from '../../components/overlay/overlayLoader.component';
import { type AccordionData } from './accordion.types';

export type AccordionProps = Readonly<{
  accordionStyle?: SerializedStyles;
  data: readonly AccordionData[];
  expandedItemStyle?: SerializedStyles;
  headerWrapperStyle?: SerializedStyles;
  isLoading?: boolean;
  itemButtonStyle?: SerializedStyles;
  itemStyle?: SerializedStyles;
  panelStyle?: SerializedStyles;
  showCount?: boolean;
  headerSize?: AccordionHeaderSize;
  testid?: string;
}>;

const noHeaderStyle = {
  display: 'none',
};

/**
 * @deprecated Use Accordion instead. Look at how this component is implemented and use its insides to compose your own.
 */
export const AccordionComponent: FC<AccordionProps> = props => {
  const convertedHeaderStyles = useMemo(() => {
    if (props.headerWrapperStyle) {
      return {
        '& > [data-element="accordion-heading-content"]': props.headerWrapperStyle,
      };
    }
    return {};
  }, [props.headerWrapperStyle]);

  return (
    <Accordion
      css={props.accordionStyle}
      data-testid={props.testid}
    >
      {props.isLoading && <OverlayLoaderComponent />}
      {props.data.map((data: AccordionData, index) => (
        <Accordion.Item
          key={index}
          css={props.itemStyle}
          data-testid={data.testId}
          open={data.isExpanded}
          isLocked={data.isLocked}
          onToggle={data.isLocked ? undefined : data.onHeadingClick}
        >
          {data.header ? (
            <Accordion.ItemHeading
              css={[props.itemButtonStyle, data.isExpanded && props.expandedItemStyle, convertedHeaderStyles]}
              size={props.headerSize}
            >
              {(data.showCount ?? props.showCount) && (
                <Accordion.StepNumber />
              )}

              {data.header}
            </Accordion.ItemHeading>
          ) : (
            <Accordion.ItemHeading css={noHeaderStyle} />
          )}
          <Accordion.Panel
            css={props.panelStyle}
          >
            {data.child}
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
